/**

 * @vuelto-surface

 * mobile: ok

 * desktop: ok

 * strategy: inherit

 *

 * Pill de caja — misma familia visual que home.day1 cashPill.

 */

import React from 'react';

import { StyleSheet, Text, View } from 'react-native';

import { Ionicons } from '@expo/vector-icons';

import type { ComponentProps } from 'react';

import { ticketColors } from '../../../shared/theme/ticketColors';



type IconName = ComponentProps<typeof Ionicons>['name'];



type Props = {

  cashOpen: boolean;

};



export function BranchCashStatusPill({ cashOpen }: Props) {

  const iconName: IconName = cashOpen ? 'card-outline' : 'lock-closed-outline';

  const iconColor = cashOpen ? ticketColors.brandInk : '#B45309';



  return (

    <View style={[localStyles.pill, cashOpen ? localStyles.pillOk : localStyles.pillWarn]}>

      <Ionicons name={iconName} size={11} color={iconColor} style={{ flexShrink: 0 }} />

      <Text style={[localStyles.text, cashOpen ? localStyles.textOk : localStyles.textWarn]} numberOfLines={1}>

        {cashOpen ? 'Caja abierta' : 'Caja cerrada'}

      </Text>

    </View>

  );

}



const localStyles = StyleSheet.create({

  pill: {

    flexDirection: 'row',

    alignItems: 'center',

    gap: 4,

    borderRadius: 999,

    paddingHorizontal: 10,

    paddingVertical: 5,

    borderWidth: 1,

    flexShrink: 0,

  },

  pillOk: {

    backgroundColor: ticketColors.brandSoft,

    borderColor: ticketColors.gold,

  },

  pillWarn: {

    backgroundColor: ticketColors.warnBg,

    borderColor: ticketColors.warnBorder,

  },

  text: {

    fontSize: 11,

    fontWeight: '700',

  },

  textOk: {

    color: ticketColors.brandInk,

  },

  textWarn: {

    color: '#B45309',

  },

});


